import React from 'react';

const NoChallengesAvailable = ({ text }) => {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  };

  const messageStyle = {
    fontSize: '1.5rem',
    color: '#555'
  };

  return (
    <div style={containerStyle}>
      <p style={messageStyle}>{text}</p>
    </div>
  );
};

export default NoChallengesAvailable;